export default __webpack_public_path__ + "src/assets/fonts/glyphicons-halflings-regular.eot";